import { AnalysisRun, AnalysisRunService } from "../services/analysis-run.service";
import { asyncCallback } from "../utils/analysis-async";
import { IAnalyzer } from "../interfaces/analyzer";
import { AnalysisResult } from "../models/analysis-result";
import { ConfigService } from "../services/config.service";
import { RiskLevel } from "../models/risk-level";
import { IAnalyzerConfig } from "../interfaces/analyzer-config";
import { MessageService } from "../services/message.service";
import { MailUtils } from "../utils/mail.utils";
import { LogService } from "../services/log.service";
import { Inject, Injector } from "@angular/core";
import { StringUtils } from "../utils/string.utils";
import { ANALYZERS, HEADERS } from "../models/constants";
import { DomainDTO } from "./../models/shared.model";
import { DomainService } from "../services/domain.service";
import { TranslateService } from "@ngx-translate/core";

export class NoReplyAnalyzer implements IAnalyzer {
    private readonly run: AnalysisRun;

    private configService: ConfigService;
    private log: LogService;
    private messageService: MessageService;
    private noReplyEmail: string;
    private isNoReplyEmail: boolean;
    private domainService: DomainService;
    private translate: TranslateService;
    constructor(
        @Inject(Injector) private injector: Injector
    ) {
        this.run = this.injector.get(AnalysisRunService).current;
        this.configService = this.injector.get(ConfigService)
        this.log = this.injector.get(LogService)
        this.messageService = this.injector.get(MessageService)
        this.domainService = this.injector.get(DomainService)
        this.translate = this.injector.get(TranslateService)
    }

    async runAnalysis(): Promise<AnalysisResult> {
        return asyncCallback<AnalysisResult>(async resolve => {
            const config: IAnalyzerConfig = this.configService.getAnalyzerConfiguration(ANALYZERS.NO_REPLY_SENDER);
            let level: RiskLevel = RiskLevel.High;
            let info: string[] = [];
            let weight: number = 0;

            try {
                if (this.run.item != null) {
                const sender: string = this.run.item.sender.emailAddress;
                const domain = MailUtils.parseMultiLevelDomain(sender);
                try {
                    this.noReplyEmail = this.messageService.getMessageHeaderValue(HEADERS.FROM).toLowerCase();
                    this.isNoReplyEmail = /\b(no[-._\s]?reply|not[-._\s]?reply|don't[-._\s]?reply)\b/.test(this.noReplyEmail);

                    const trustedDomains: DomainDTO[] = this.domainService.getDomains();
                    const personalTrusted = this.domainService.loadPersonalTrustedListFromCache();
                    
                    const isTrusted = 
                    trustedDomains.some(value => StringUtils.compareCaseInsensitive(value.domain, domain)) ||
                    personalTrusted.domains.has(domain.toLowerCase()) || personalTrusted.emails.has(sender.toLowerCase());
                    
                    if (this.isNoReplyEmail) {
                    level = RiskLevel.Low;
                    info.push(this.translate.instant('analyzer.no_reply_email_address'));
                    } else if (!this.isNoReplyEmail && isTrusted) {
                    level = RiskLevel.Moderate;
                    info.push(this.translate.instant('analyzer.trusted_but_no_reply_sender'));
                    } else {
                    level = RiskLevel.High;
                    info.push(this.translate.instant('analyzer.untrusted_and_not_no_reply_sender'));
                    }
                } catch (e) {
                    level = RiskLevel.Unknown;
                    info.push(this.translate.instant('analyzer.no_internet_headers')); 
                    this.log.logException(
                    new Error(`${this.translate.instant('analyzer.error_analyzing_no_reply_sender')} - ${JSON.stringify(e)}`));
                }
                }
            } catch (e) {
                console.error(this.translate.instant('analyzer.error-while-analyzing-no-reply'), e);
            }

            resolve(new AnalysisResult(config.displayName, level, weight, config.description!, info));
        });
    }
}
